<script setup lang="ts">
import { Icon } from '@dabble/quillui';

defineProps<{
  checked: boolean;
}>();
</script>

<template>
  <Icon
    :name="checked ? 'checkmark-circle' : 'circle'"
    :class="['checkmark', { 'checkmark--checked': checked }]"
    size="medium"
    aria-hidden="true"
  />
</template>

<style scoped>
.checkmark {
  display: inline-flex;
  flex-shrink: 0;
}

.checkmark--checked {
  color: var(--color-fg-success);
}
</style>
